import * as queryString from 'query-string';
import React from 'react';
import { Redirect, Route } from 'react-router';

// Replace the current URL with one with no `tab` search string
export const RedirectToDefaultTab = () => (
  <Route>
    {({ history }) => (
      <Redirect
        push={false}
        to={{
          ...history.location,
          search: queryString.stringify({
            ...queryString.parse(history.location.search),
            tab: undefined,
          }),
        }}
      />
    )}
  </Route>
);
